export default {
    'form.name':'Full Name',
    'form.email':'Email',
    'form.email.code':'Verification code',
    'form.country':'Country',
    'form.password':'Password',
    'form.requiredText':'Please enter ',
    "form.send-email-success": "Verification code sent successfully",
    "form.send-email-fail": "Failed to send verification code",
    "form.send-email-code": "Get Verification Code",
    "form.email-valid-error": "Invalid email format",
    "form.second-send-again": "s Send Again",
    'form.upload.idFront':'Front side of the ID car',
    'form.upload.idBack':'Back side of the ID card',
    'form.last-name':'Last Name',
    'form.first-name':'Last Name',
    'form.birthday':'Birthday',
    'form.nickname':'Nickname',
    'form.phone':'Phone',
    'form.state':'State',
    'form.city':'City',
    'form.address':'Address',
    'form.reset':'Reset',
    'form.submit':'Submit',
    'form.registe-success':'Registe success',
    'form.login-success':'Login success',
    'form.policy.title':'Privacy Policy',
    'form.policy.require':'Please review and agree to the Privacy Policy',
    'form.policy.text':'View Privacy Policy',
    'form.submit.success':'Submit Success',
    'form.submit.fail':'Submit Failed',
}